import DueDiligenceRiskModule from './DueDiligenceRiskModule';

export default DueDiligenceRiskModule;
